import React, { useState, useEffect,useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { addItem, getAllBillByOrgId, itemList } from "../services/api";
import { useUser } from "../context/UserContext";
import { ToastContainer, toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";

const AddItem = ({ handleCloseAddDialog }) => {
  const [itemId, setItemId] = useState("");
  const [item_id, setItem_id] = useState("");
  const [billId, setBillId] = useState("");
  const [billName, setBillName] = useState("");
  const [stockQuantity, setstockQuantity] = useState("");
  const [brand, setBrand] = useState("");
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [bills, setBills] = useState([]);
  const [itemsList, setItemsList] = useState([]);
  const { user } = useUser();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cases,SetCases] = useState("");
  
  const itemInputRef = useRef(null);


  // get all bills by orgId
  const fetchBills = async (orgId) => {
    try {
      const response = await getAllBillByOrgId(orgId);
      if (response?.status === 200 && Array.isArray(response.data.data)) {

        setBills(response.data.data);
      } else {
        setBills([]);
      }
    } catch (error) {
      console.error("Failed to fetch bills:", error);
      setBills([]);
    }
  };

  //get all itemList
  const fetchItemList = async () => {
    try {
      const response = await itemList(user?.orgId);
      if (response.status === 200 && Array.isArray(response.data)) {
        // Sort the data by itemId in ascending order
        const sortedData = response.data.sort((a, b) => a.itemId - b.itemId);
        setItemsList(sortedData);
        console.log(sortedData);
      } else {
        setItemsList([]);
      }
    } catch (error) {
      console.error("Failed to fetch items:", error);
      setItemsList([]);
    }
  };


  useEffect(() => {
    console.log("User Org ID:", user?.orgId); // Debug log
    if (user?.orgId) {
      fetchBills(user.orgId);
      fetchItemList();
    }
  }, [user]);

  const handleItemChange = (selectedItemName) => {
    console.log(selectedItemName);
    const selectedItem = itemsList.find(item => item.itemsName == selectedItemName);
    if (selectedItem) {
      setItem_id(selectedItem._id);
    }
    setBrand(selectedItemName);
    setQuantity("");
    setPrice("");
    setSellingPrice("");
  };

  const handleQuantityChange = (selectedQuantity) => {
    setQuantity(selectedQuantity);
    SetCases("");
    setstockQuantity("");

    // Find the matching item from the list
    const selectedItem = itemsList.find(
      (item) => item.itemsName === brand && item.itemsUnits === selectedQuantity
    );

    if (selectedItem) {
      setPrice(selectedItem.issuePrice || 0);
      setSellingPrice(selectedItem.mrp || 0);
      setItemId(selectedItem.itemId || "");
    } else {
      setPrice("");
      setSellingPrice("");
    }
  };

  const handleSubmit = async (e) => {

    // Prevent multiple submissions
    setIsSubmitting(true);

    e.preventDefault();
    const newItem = {
      itemId,
      item_id,
      itemName: `${brand} ${itemId}(${quantity})`,
      item_quantity: quantity,
      item_cost: Number(price),
      item_sellingCost: Number(sellingPrice),
      billId,
      billName,
      item_stockQuantity: stockQuantity,
      orgId: user.orgId,
      isActive: true,
      createdBy:user.userId,
      updatedBy:user.userId,
    };
    console.log(newItem);
    if (
      !itemId ||
      !brand ||
      !quantity ||
      !price ||
      !sellingPrice ||
      !billId ||
      stockQuantity <= 0
    ) {
      toast.error("Please fill in all required fields.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await addItem(newItem);
      if (response.data.success) {
        toast.success("Item added successfully");
        setBrand("");
        setQuantity("");
        setPrice("");
        setstockQuantity("");
        setSellingPrice("");
        SetCases("");
        itemInputRef.current?.focus();

        
      } else {
        toast.error(response.data.message || "Error adding item");
      }
    } catch (error) {
      console.error("Error adding item:", error);
      toast.error(error.response?.data?.message || "Error adding item");
    }
    finally {
      // Re-enable the button after processing
      setIsSubmitting(false);
    }
  };

  // Function to remove duplicate items based on item name
  const getUniqueItems = (items) => {
    const uniqueItems = Array.from(
      new Set(items.map((item) => item.itemsName))
    ).map((itemName) => items.find((item) => item.itemsName === itemName));
    return uniqueItems;
  };

  const handleRest = () => {
    setBrand("");
    setQuantity("");
    setPrice("");
    setstockQuantity("");
    setSellingPrice("");
    setBillId("");
    SetCases("");
  }

  const calculateBottles = (cases, quantity) => {
    const mlValue = parseInt(quantity, 10);
    const casesValue = parseInt(cases, 10);

    if (!casesValue || !mlValue) {
      return 0; // If cases or ml is not valid, return 0
    }

    let bottlesPerCase = 0;

    if ([750, 650, 700].includes(mlValue)) {
      bottlesPerCase = 12;
    } else if ([500, 375, 330, 275,200].includes(mlValue)) {
      bottlesPerCase = 24;
    } else if (mlValue === 180) {
      bottlesPerCase = 48;
    } else if (mlValue === 90) {
      bottlesPerCase = 96;
    } else if ([50,60].includes(mlValue)) {
      bottlesPerCase = 192;
    } else if (mlValue === 1000) {
      bottlesPerCase = 9;
    }
    else {
      return 0; // Invalid ml value
    }

    return casesValue * bottlesPerCase;
  };



  const handleCasesChange = (e) => {
    SetCases(e.target.value);
    setstockQuantity(calculateBottles(e.target.value, quantity));
  };

  return (
    <Container>
      <ToastContainer />
      <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 450 },
              bgcolor: "background.paper",
              boxShadow: 24,
              p: { xs: 2, sm: 3 },
              borderRadius: 2,
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
      <Box sx={{  display: "flex", justifyContent: "center" }}>
        <Box elevation={3} sx={{ padding: "0px 10px 10px 10px", maxWidth: 400, width: "100%" }}>
          <Typography variant="h5" gutterBottom color="primary" sx={{display:"inline"}}>
            Add Beverage Item
          </Typography>
          <IconButton
            onClick={handleCloseAddDialog}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                sx={{marginTop:"10px"}}
                  options={bills}
                  getOptionLabel={(bill) => bill.billName}
                  value={billId ? bills.find((bill) => bill._id === billId) : null}
                  onChange={(e, selectedBill) => {
                    if (selectedBill) {
                      setBillId(selectedBill._id);
                      setBillName(selectedBill.billName);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Bills"
                      placeholder="Select Bill"
                      fullWidth
                      size="small"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  options={getUniqueItems(itemsList)}
                  getOptionLabel={(item) => `${item.itemsName} (${item.itemId})`}
                  value={brand ? getUniqueItems(itemsList).find((item) => item.itemsName === brand) : null}
                  onChange={(e, selectedItem) => {
                    if (selectedItem) {
                      handleItemChange(selectedItem.itemsName);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Items"
                      placeholder="Select Item"
                      fullWidth
                      size="small"
                      inputRef={itemInputRef}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel>Quantity</InputLabel>
                  <Select
                    value={quantity}
                    onChange={(e) => handleQuantityChange(e.target.value)}
                    label="Quantity"
                    size="small"
                  >
                    {["50ml","60ml", "90ml", "180ml","200ml", "275ml", "330ml", "375ml", "500ml", "650ml", "700ml","750ml", "1000ml", "2000ml"].map(
                      (q, index) => (
                        <MenuItem key={index} value={q}>
                          {q}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Price"
                  variant="outlined"
                  fullWidth
                  value={price}
                  InputProps={{ readOnly: true }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Selling Price"
                  variant="outlined"
                  fullWidth
                  value={sellingPrice}
                  InputProps={{ readOnly: true }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="No of Cases"
                  variant="outlined"
                  fullWidth
                  type="number"
                  value={cases}
                  onChange={handleCasesChange}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) =>
                    e.key === "ArrowUp" || e.key === "ArrowDown"
                      ? e.preventDefault()
                      : null
                  } // Disables arrow keys
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Stock Quantity"
                  variant="outlined"
                  fullWidth
                  type="number"
                  value={stockQuantity}
                  onChange={(e)=>setstockQuantity(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) =>
                    e.key === "ArrowUp" || e.key === "ArrowDown"
                      ? e.preventDefault()
                      : null
                  } // Disables arrow keys
                  required
                  size="small"
                />
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: "flex-end", alignItems: "center", textTransform: "none" }}>
              <Box><Button sx={{ background: "#ED3EF7", borderRadius: "5px", marginTop: "15px", marginRight: "10px", textTransform: "none", color: "white" }} onClick={handleRest}>Reset</Button></Box>
              <Box > <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ marginTop: 2,textTransform:"none" }}
              >
                {isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Add Item"}
              </Button></Box>
            </Box>

          </form>
        </Box>
      </Box>
      </Box>
    </Container>
  );
};

export default AddItem;
